import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import toast, {Toaster} from "react-hot-toast";

import styles from './PaymentPage.module.scss';
import AddressDetailsOrder from "../../components/AddressDetailsOrder/AddressDetailsOrder";
import PackageDetailsOrder from "../../components/PackageDetailsOrder/PackageDetailsOrder";
import AdditionalInfoOrder from "../../components/AdditionalInfoOrder/AdditionalInfoOrder";
import AddedPhotosCustomerOrder from "../../components/AddedPhotosCustomerOrder/AddedPhotosCustomerOrder";
import CleanerShortDetails from "../../components/CleanerShortDetails/CleanerShortDetails";
import Loader from "../../components/Loader/Loader";
import MainButtonTransparentBackground
  from "../../components/UI/MainButtonTransparentBackground/MainButtonTransparentBackground";
import MainButtonWithBackground from "../../components/UI/MainButtonWithBackground/MainButtonWithBackground";
import {offerService} from "../../services/offer.service";
import {resolveMediaUrl} from "../../configs/urls";
import {MAIN_ROUTES} from "../../routing/main_routes";
import {Backdrop, Box, Fade, Modal} from "@mui/material";
import ModalPrivacyPolicy from "../../components/ModalPrivacyPolicy/ModalPrivacyPolicy";

const PaymentPage = () => {
  const {state} = useLocation();

  const navigate = useNavigate();

  const {offer, status} = useSelector(state => state.offer);

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    return () => {
      toast.remove("create-offer");
    }
  }, []);

  if (status === 'loading') {
    return <Loader/>;
  }

  if (!state) {
    navigate(MAIN_ROUTES.MAIN);
  }

  const {
    pk: id,
    address,
    city,
    request_datetime,
    get_total_price,
    cleaning_type,
    room_count,
    pano_window_count,
    reg_window_count,
    wc_count,
    services,
    present_at_home,
    comment,
    present_at_home_desc,
    photos,
    cleaner_applications,
    request_price,
    service_package
  } = state?.cleaning_request || {};

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 4
  };

  const {first_name, last_name, mobile_nummer, photos: cleaner_photos} = state?.application?.created_by_user || {};

  return (
    <div className={styles.paymentPage_wrapper}>
      <div className={styles.paymentPage}>
        <h1>Оплатити замовлення</h1>

        <div className={styles.paymentPage_details}>
          <AddressDetailsOrder
            date={new Date(request_datetime).toLocaleDateString()}
            address={address}
            price={null}
            time={new Date(request_datetime).toLocaleTimeString()}
          />
          <PackageDetailsOrder
            style={{'padding': '24px 24px 16px 24px', 'borderBottom': '1px solid #D9DBDD'}}
            showTitle={true}
            typeCleaning={cleaning_type}
            countRooms={room_count}
            countBathrooms={wc_count}
            countOrdinaryWindows={reg_window_count}
            countPanoramicWindows={pano_window_count}
            services={services}
            selectedPackage={service_package?.name}
          />
          <CleanerShortDetails
            photo={resolveMediaUrl(cleaner_photos?.[0])} //it is profile photo
            firstName={first_name}
            lastName={last_name}
            phoneNumber={""}
          />
          <AdditionalInfoOrder
            isBorderBottom={photos?.length > 0}
            present_at_home={present_at_home}
            additionalComments={comment}
            present_at_home_desc={present_at_home_desc}
          />
          {photos?.length > 0 && <AddedPhotosCustomerOrder photos={photos}/>}
        </div>

        <div className={styles.paymentPage_buttons}>
          <MainButtonTransparentBackground
            type={'button'} //submit or button
            text={'Назад'}
            onClick={() => navigate(-1)}
            condition={false} // is disabled button
            width={'auto'}
          />
          <MainButtonWithBackground
            type={'button'} //submit or button
            text={`Оплатити ₴${state?.application?.application_price || get_total_price || +request_price}`}
            onClick={() => setIsModalOpen(true)}
            condition={false} // is disabled button
            width={'auto'}
          />

          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={isModalOpen}
            onClose={setIsModalOpen}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={isModalOpen}>
              <Box sx={style}>
                <ModalPrivacyPolicy
                  handleClose={() => setIsModalOpen(false)}
                  type={'customer'}
                  cleaning_request={state?.cleaning_request}
                  application={state?.application}
                />
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>

      {/*to appear hot toast notification*/}
      <Toaster/>
    </div>
  );
};

export default PaymentPage;
